// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ValWK","header":"ReportDetails_header__1a9_J","title":"ReportDetails_title__uNBL5","left":"ReportDetails_left__2Qnpq"};